export default __webpack_public_path__ + "static/media/logo-sm.f6b71fbd.png";